import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopupRef, PopupService } from '@progress/kendo-angular-popup';
import { State } from '@progress/kendo-data-query/dist/npm/state';
import {
  cloudIcon,
  moreVerticalIcon,
  SVGIcon,
  xIcon,
} from '@progress/kendo-svg-icons';
import { BehaviorSubject, finalize, Observable, Subject, takeUntil } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { StudentService } from 'src/app/services/student.service';
import { AbstractComponent } from 'src/app/shared/components/abstract-component';
import { ColumnType } from 'src/app/shared/enums/column-type';
import { MeetingType } from 'src/app/shared/enums/meeting-type';
import { ColumnComponentInputs } from 'src/app/shared/interfaces/column-component-inputs';
import {
  GridDataResponse,
  NestedGridRequest,
} from 'src/app/shared/interfaces/grid-data-response';
import { StudentProfile } from 'src/app/shared/interfaces/student-profile';
import { User } from 'src/app/shared/models/user';
import { GridService } from 'src/app/shared/services/grid.service';
import { AuthStore } from 'src/app/stores/auth.store';
import { StageActions } from '../../interface/actions-response';
import {
  DashboardEvalResponse,
  DashboardResponse,
  EvaluationList,
} from '../../interface/dashboard-response';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-evaluations-tab',
  templateUrl: './evaluations-tab.component.html',
  styleUrls: ['./evaluations-tab.component.scss'],
  standalone: false,
})
export class EvaluationsTabComponent
  extends AbstractComponent
  implements OnInit {
  evalActions: StageActions;
  @Input() studentDetails: DashboardResponse;
  studentProfile!: StudentProfile;

  columnTypeEnum: typeof ColumnType = ColumnType;
  columnDefinitions: ColumnComponentInputs[] = [
    {
      title: 'Actions',
      field: '',
      icon: moreVerticalIcon,
      columnType: ColumnType.icon,
      autoSize: false,
      width: 50,
    },
    {
      title: 'Assessments In Progress',
      field: 'evaluationName',
      columnType: ColumnType.text,
      width: 250,
    },
    {
      title: 'Agency Name',
      field: 'agencyName',
      columnType: ColumnType.text,
      autoSize: false,
      width: 250,
    },
    {
      title: 'Evaluator Name',
      field: 'evaluatorName',
      columnType: ColumnType.text,
      autoSize: false,
      width: 250,
    },
    {
      title: 'Evaluator Type',
      field: 'evaluatorType',
      columnType: ColumnType.text,
      width: 200,
    },
    {
      title: 'Evaluation Due Date',
      field: 'dueDate',
      columnType: ColumnType.text,
      width: 180,
    },
    {
      title: 'Status',
      field: 'evaluationStatus',
      columnType: ColumnType.text,
      width: 200,
    },
  ];
  xIcon: SVGIcon = xIcon;
  cloudIcon: SVGIcon = cloudIcon;
  public actionIcon: SVGIcon = moreVerticalIcon;

  initialNestedGridState: State = {
    skip: 0,
    take: 20,
    sort: [{ dir: 'asc', field: 'evaluationName' }],
    group: [],
  };
  gridData: DashboardEvalResponse;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  user: User;
  popupRef: PopupRef;
  showRequestExtensionDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showScheduleMeetingAssessmentDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  meetingType: MeetingType;
  meetingSk: string;
  actionText: string;
  isReSchedule: boolean;
  selectedEvalRowDetails: EvaluationList;

  constructor(
    private gridService: GridService,
    private authStore: AuthStore,
    private dashboardService: DashboardService,
    private popupService: PopupService,
    private router: Router,
    private studentService: StudentService,
    private loadingService: LoadingService
  ) {
    super();
    this.authStore.UserInfo$.pipe(takeUntil(this.componentDestroyed)).subscribe(
      (userInfo: User) => {
        this.user = userInfo;
      }
    );
  }
  checkStatus(status: string): boolean {
    if (status === 'AT Referral: Rejected' || status === 'AT Referral: More Information Needed') {
      return true
    } else {
      return false;
    }
  }
  ngOnInit(): void {
    this.dashboardService.reloadEvalGridData$.subscribe((data: boolean) => {
      if (data) {
        this.sendRequestNested();
      }
    });
    this.sendRequestNested();
    this.dashboardService.closeActionOnDashboardEvalSubject.subscribe((res: boolean) => {
      // Unsure why above observable is needed, but checking if res is true to avoid unnecessary call
      if (res)
        this.sendRequestNested();
    });
    //this.getStudentProfileDetails();
  }

  getStudentProfileDetails(): void {
    this.studentService
      .studentProfile(this.studentDetails?.nycid)
      .subscribe((response: StudentProfile) => {
        this.studentProfile = response;
      });
  }

  sendRequestNested(): void {
    this.loadingService.show()

    this.dashboardService
      .getEvalsData(this.studentDetails?.referralSK)
      ?.pipe(takeUntil(this.ngUnsubscribe), finalize(() => this.loadingService.hide()))
      .subscribe((response: DashboardEvalResponse) => {
        this.gridData = { ...response };
      });
  }

  queryNestedGridService(
    data: NestedGridRequest
  ): Observable<GridDataResponse> {
    return this.gridService.nestedGridQuery('evaluationsNested', data);
  }

  loadActions(event: MouseEvent | KeyboardEvent, row: EvaluationList): void {
    event?.stopPropagation();
    this.evalActions = {} as StageActions;

    this.dashboardService
      .getEvalActionItems(this.studentDetails?.studentSK, row?.evaluationSk)
      .subscribe((res: StageActions) => {
        this.evalActions = { ...res };
      });
  }

  closePopup(): void {
    this.popupRef?.close();
    this.popupRef = null;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  override afterOnDestroy(): void { }
}
